'use client'

import { useEffect } from 'react'

import { setGa4ClientId } from '@/utils/ga4ClientId'
import { setSourceUrl } from '@/utils/sourceUrl'
import { setDocumentReferrer } from '@/utils/referrer'

export const ReferrerTracker = () => {
  useEffect(() => {
    setSourceUrl()
    setGa4ClientId()
    setDocumentReferrer()
  }, [])

  return null
}
